export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100 font-heading mb-3">
            关于我们
          </h2>
          <p className="text-sm text-foreground-500 max-w-[480px] mx-auto">
            了解日皮视频平台的定位、理念与核心优势
          </p>
        </div>
        <div className="max-w-[800px] mx-auto">
          <div className="p-8 md:p-10 rounded-2xl bg-background-100 border border-background-200/60">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/15">
                <i className="ri-vidicon-line text-2xl text-primary-400"></i>
              </div>
              <div>
                <h3 className="text-lg font-bold text-foreground-100 font-heading">日皮视频</h3>
                <p className="text-xs text-foreground-500">精品视频内容聚合平台</p>
              </div>
            </div>
            <div className="space-y-4 text-sm text-foreground-500 leading-relaxed">
              <p>
                日皮视频是一个专注于精品视频内容聚合的在线观影平台。我们深度整合<strong className="text-foreground-300">蜜桃视频</strong>与<strong className="text-foreground-300">红桃视频</strong>的独家推荐资源，同步覆盖<strong className="text-foreground-300">香蕉视频</strong>、<strong className="text-foreground-300">樱花视频</strong>等热门品牌的VIP免费内容，致力于为用户提供一站式的优质观影体验。
              </p>
              <p>
                平台核心优势在于精细化内容筛选与智能推荐机制。通过多维热度算法与编辑团队的专业评审，每日更新特色专题与热播排行榜，帮助用户在海量内容中快速发现真正值得观看的好视频。全线配备高清CDN加速与自适应码率技术，确保高清流畅不缓冲的播放品质。
              </p>
              <p>
                日皮视频秉持"精选、高清、便捷"的产品理念，持续优化内容更新频率与平台播放体验。无论你偏好蜜桃视频的独家推荐，还是想探索红桃视频的编辑力荐，抑或追踪香蕉视频与樱花视频的最新内容，日皮视频都能为你提供最高效的发现路径。
              </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8 pt-6 border-t border-background-200/60">
              <div className="text-center">
                <div className="text-xl font-bold text-primary-500 font-heading">5000+</div>
                <div className="text-xs text-foreground-600 mt-1">精选片源</div>
              </div>
              <div className="text-center">
                <div className="text-xl font-bold text-accent-400 font-heading">6</div>
                <div className="text-xs text-foreground-600 mt-1">品牌频道</div>
              </div>
              <div className="text-center">
                <div className="text-xl font-bold text-foreground-300 font-heading">每日</div>
                <div className="text-xs text-foreground-600 mt-1">内容更新</div>
              </div>
              <div className="text-center">
                <div className="text-xl font-bold text-secondary-400 font-heading">1080P</div>
                <div className="text-xs text-foreground-600 mt-1">高清画质</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}